/* src/app/system-utils/search-dialog/search-dialog.component.css */
:host {
  display: flex;
  flex-direction: column;
  height: 75vh;
  margin: 5px;
  font-family: var(--tem-font-family);
}
.search-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  gap: var(--tem-space-3);
  padding: var(--tem-space-2);
}
.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.dialog-header-text {
  display: flex;
  flex-direction: column;
}
.dialog-title {
  margin: 0;
  font-size: var(--tem-fs-lg);
  font-weight: 600;
  color: var(--tem-ink);
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
}
.dialog-subtitle {
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
}
.search-bar {
  display: flex;
  gap: var(--tem-space-2);
  align-items: center;
}
.scope-select {
  width: 220px;
  min-width: 180px;
}
.search-input {
  flex: 1;
}
.search-icon {
  color: var(--tem-muted);
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.table-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.result-row {
  cursor: pointer;
}
.result-row td {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 300px;
}
tr.selected-row td {
  background: var(--tem-accent-soft) !important;
}
.dialog-footer {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
}
.rows-info {
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
}
.flex-spacer {
  flex-grow: 1;
}
/*# sourceMappingURL=search-dialog.component.css.map */
